export default __webpack_public_path__ + "static/Ketlen Nascimento_MiniBio-9cdd561352298c7276be796e069b446a.webp";